import { render } from "./ButtonEdit.vue?vue&type=template&id=782a6a2c&scoped=true"
import script from "./ButtonEdit.vue?vue&type=script&lang=js"
export * from "./ButtonEdit.vue?vue&type=script&lang=js"

import "./ButtonEdit.vue?vue&type=style&index=0&id=782a6a2c&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782a6a2c"]])

export default __exports__